import * as React from 'react';

// Components
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import Button from '../Button';
import { AiGemIcon } from '../icons';

// Services

type SelectionSidebarHeaderProps = {
  title: string;
  count?: number;
  extra?: React.ReactNode;
  useAlphaFeedbackStyle?: boolean;
  showDraftingSpecialistSection?: boolean;
};

const SelectionSidebarHeaderDraftingSpecialistSection = () => (
  <div className="p-4 border-b border-gray-200">
    <h3 className="text-sm font-semibold mb-2 flex items-center gap-2">
      <AiGemIcon className="w-5 h-5 flex-shrink-0" />
      Create templates from documents
    </h3>
    <div className="ml-7">
      <p className="text-sm mb-4">
        Leverage AI to create reusable templates from your own documents or from
        Clio Manage documents.
      </p>
      <Link to="/templates/setup">
        <Button primary small>
          Select documents
        </Button>
      </Link>
    </div>
  </div>
);

export const SelectionSidebarHeader = ({
  title,
  count,
  extra,
  useAlphaFeedbackStyle = false,
  showDraftingSpecialistSection = false,
}: SelectionSidebarHeaderProps) => {
  if (useAlphaFeedbackStyle) {
    return (
      <Typography variant="h1" fontSize={'16px'} padding={'18px 12px'}>
        {title} ({count})
      </Typography>
    );
  }

  return (
    <>
      {showDraftingSpecialistSection && (
        <SelectionSidebarHeaderDraftingSpecialistSection />
      )}
      <div className="flex justify-between p-3 flex-col lg:flex-row gap-3">
        <div className="pt-2">
          <h3>
            <span className="font-medium mr-2">{title}</span>
            <span className="text-xs rounded-full	bg-gray-200	p-1 px-2 font-medium">
              {count}
            </span>
          </h3>
        </div>
        <div>{extra}</div>
      </div>
    </>
  );
};
